// import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';
// import "slick-carousel";


document.addEventListener('DOMContentLoaded', () => {
  const headerComponent = document.querySelector('#header-component');
  const topBar = document.querySelector('.top-header-bar');

  if (!headerComponent) return;

  let lastScrollY = window.scrollY;

  function updateHeaderState() {
    const isScrolled = window.scrollY > 0;

    if (isScrolled) {
      if (!headerComponent.classList.contains('is-fixed')) {
        const headerHeight = headerComponent.offsetHeight;
        document.body.style.paddingTop = `${headerHeight}px`;
      }

      headerComponent.classList.add('is-fixed');

      if (topBar) {
        topBar.classList.add('is-hidden');
      }
    } else {
      headerComponent.classList.remove('is-fixed');
      document.body.style.paddingTop = '';

      if (topBar) {
        topBar.classList.remove('is-hidden');
      }
    }

    lastScrollY = window.scrollY;
  }

  let ticking = false;

  function onScrollOrResize() {
    if (ticking) return;

    ticking = true;

    requestAnimationFrame(() => {
      updateHeaderState();
      ticking = false;
    });
  }

  updateHeaderState();

  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);
  document.addEventListener('shopify:section:load', onScrollOrResize);
  document.addEventListener('shopify:section:reorder', onScrollOrResize);

  (function () {
    const GROUP_CONTAINER_SELECTOR = '.resource-list--grid';
    const CARD_SELECTOR = '.p-card';
    const TARGET_SELECTORS = ['.p-card__title', '.p-card__helps-with'];

    const rafThrottle = (fn) => {
      let scheduled = false;
      return (...args) => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          fn(...args);
        });
      };
    };

    function resetHeights(container) {
      TARGET_SELECTORS.forEach(sel => {
        container.querySelectorAll(sel).forEach(el => {
          el.style.minHeight = '';
        });
      });
    }

    function equalizeInContainer(container) {
      if (!container) return;

      resetHeights(container);

      TARGET_SELECTORS.forEach(sel => {
        const elements = Array.from(container.querySelectorAll(sel))
          .filter(el => el.offsetParent !== null);

        if (!elements.length) return;

        let max = 0;

        elements.forEach(el => {
          const h = el.getBoundingClientRect().height;
          if (h > max) max = h;
        });

        elements.forEach(el => {
          el.style.minHeight = `${Math.ceil(max)}px`;
        });
      });
    }

    function run() {
      const groups = document.querySelectorAll(GROUP_CONTAINER_SELECTOR);
      if (!groups.length) return;

      groups.forEach(group => {
        if (!group.querySelector(CARD_SELECTOR)) return;
        equalizeInContainer(group);
      });
    }

    const runThrottled = rafThrottle(run);

    window.addEventListener('load', runThrottled);
    window.addEventListener('resize', runThrottled);
    document.addEventListener('shopify:section:load', runThrottled);
    document.addEventListener('shopify:section:reorder', runThrottled);

    const mo = new MutationObserver(runThrottled);
    mo.observe(document.documentElement, { childList: true, subtree: true });

    runThrottled();
  })();
});

document.addEventListener('DOMContentLoaded', () => {
  const movePaymentTerms = () => {
    const paymentTerms = document.querySelector('shopify-payment-terms, .shopify-payment-terms');
    const target = document.querySelector('.product-form-buttons');

    if (!paymentTerms || !target) return;

    if (paymentTerms.dataset.moved === 'true') return;

    target.insertAdjacentElement('afterend', paymentTerms);
    paymentTerms.dataset.moved = 'true';
  };

  setTimeout(movePaymentTerms, 300);
  setTimeout(movePaymentTerms, 800);
  setTimeout(movePaymentTerms, 1500);

  document.addEventListener('shopify:section:load', movePaymentTerms);
});

(function () {
  const MOBILE_WIDTH = 768;
  const WRAP_CLASS = 'p-thumbs-wrap';
  const NAV_CLASS = 'p-thumb-nav';
  const PREV_CLASS = 'p-thumb-nav--prev';
  const NEXT_CLASS = 'p-thumb-nav--next';

  function createArrow(direction) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `${NAV_CLASS} ${direction === 'prev' ? PREV_CLASS : NEXT_CLASS}`;
    button.setAttribute('aria-label', direction === 'prev' ? 'Scroll thumbnails left' : 'Scroll thumbnails right');

    button.innerHTML =
      direction === 'prev'
        ? `
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M14.5 6L8.5 12L14.5 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `
        : `
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M9.5 6L15.5 12L9.5 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `;

    return button;
  }

  function getScrollStep(thumbs) {
    const firstThumb = thumbs.querySelector('.p-thumb');
    if (!firstThumb) return 120;

    const thumbStyles = window.getComputedStyle(thumbs);
    const gap = parseFloat(thumbStyles.columnGap || thumbStyles.gap || 0);
    return firstThumb.offsetWidth + gap;
  }

  function updateButtons(thumbs, prevBtn, nextBtn) {
    if (window.innerWidth > MOBILE_WIDTH) {
      prevBtn.classList.add('is-hidden');
      nextBtn.classList.add('is-hidden');
      return;
    }

    const hasOverflow = thumbs.scrollWidth > thumbs.clientWidth + 2;

    if (!hasOverflow) {
      prevBtn.classList.add('is-hidden');
      nextBtn.classList.add('is-hidden');
      return;
    }

    prevBtn.classList.remove('is-hidden');
    nextBtn.classList.remove('is-hidden');

    const maxScrollLeft = thumbs.scrollWidth - thumbs.clientWidth;
    const currentScroll = Math.ceil(thumbs.scrollLeft);

    if (currentScroll <= 2) {
      prevBtn.classList.add('is-disabled');
    } else {
      prevBtn.classList.remove('is-disabled');
    }

    if (currentScroll >= maxScrollLeft - 2) {
      nextBtn.classList.add('is-disabled');
    } else {
      nextBtn.classList.remove('is-disabled');
    }
  }

  function initThumbSlider(thumbs) {
    if (!thumbs || thumbs.dataset.thumbNavInit === 'true') return;

    thumbs.dataset.thumbNavInit = 'true';

    let wrapper = thumbs.parentElement;

    if (!wrapper.classList.contains(WRAP_CLASS)) {
      const newWrapper = document.createElement('div');
      newWrapper.className = WRAP_CLASS;
      wrapper.insertBefore(newWrapper, thumbs);
      newWrapper.appendChild(thumbs);
      wrapper = newWrapper;
    }

    const prevBtn = createArrow('prev');
    const nextBtn = createArrow('next');

    wrapper.appendChild(prevBtn);
    wrapper.appendChild(nextBtn);

    prevBtn.addEventListener('click', function () {
      const step = getScrollStep(thumbs);
      thumbs.scrollBy({
        left: -step * 2,
        behavior: 'smooth'
      });
    });

    nextBtn.addEventListener('click', function () {
      const step = getScrollStep(thumbs);
      thumbs.scrollBy({
        left: step * 2,
        behavior: 'smooth'
      });
    });

    thumbs.addEventListener('scroll', function () {
      updateButtons(thumbs, prevBtn, nextBtn);
    });

    window.addEventListener('resize', function () {
      updateButtons(thumbs, prevBtn, nextBtn);
    });

    setTimeout(function () {
      updateButtons(thumbs, prevBtn, nextBtn);
    }, 100);
  }

  function initAllThumbs() {
    document.querySelectorAll('.p-thumbs[data-thumbs], .p-thumbs').forEach(initThumbSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllThumbs);
  } else {
    initAllThumbs();
  }

  function startThumbObserver() {
    const observerTarget = document.body || document.documentElement;

    if (!observerTarget) return;

    const observer = new MutationObserver(function () {
      initAllThumbs();
    });

    observer.observe(observerTarget, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startThumbObserver);
  } else {
    startThumbObserver();
  }
})();


